import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Router, NavigationStart } from '@angular/router';
import { Select } from '@ngxs/store';
import { Enlace } from './../../../store/global/global.state';
import { Post } from 'src/app/store/global/global.state';
import { Integration } from 'src/app/store/integrations/integrations.state';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterContentInit, OnDestroy {

  unsubscribe$ = new Subject<void>();

  @Select((state: any) => state.global.slugInstitucion) slugInstitucion$!: Observable<any>;
  @Select((state: any) => state.global.postsCarrousel) postsCarrousel$!: Observable<Post[]>;
  @Select((state: any) => state.global.enlacesEncabezado) enlaces$!: Observable<Enlace[]>;
  @Select((state: {integrations: {integrations: Integration[]}}) => state.integrations.integrations)
  integration$: Observable<Integration[]>;

  rutaInstitucion!: string;
  urlInstitucion!: string;
  isHome: boolean = false;
  isHandset$: Observable<boolean>; 

  constructor(
    private router: Router,
    breakpointObserver: BreakpointObserver
  ) {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.rutaInstitucion = event.url;
          this.rutaInstitucion = this.rutaInstitucion.slice(1, this.rutaInstitucion.length);
          this.isHome = (this.rutaInstitucion === 'inicio' || !this.rutaInstitucion);
        }
      });

    this.isHandset$ = breakpointObserver.observe([ 
      '(max-width: 1024px)' 
    ])
    .pipe(map(result => result.matches));
  }

  ngOnInit(): void {
    this.urlInstitucion = window.location.host.toString();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterContentInit(): void {}


  /**
   * Chequea si se encuentra en la institución de Espacio MO y si el link es para una página de servicios.
   * En ese caso, devuelve false para no mostrar el link en el header.
   * En cualquier otro caso, devuelve true.
   * NOTA: Este mecanismo solo funciona para la institución de Espacio MO. debe analizar si se puede mejorar para
   * brindar una solución más general.
   * @param link El link a ser chequeado.
   * @returns True si el link puede ser mostrado, false en caso contrario.
   */
  checkCustomUrl(link: string): boolean {
    if (this.urlInstitucion.includes('espaciomo') == true) {
      if(link.includes('/servicios') == true) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }

  navigateCustomUrl(link: string): void {
    if (link.indexOf('/') === 0) {
      this.router.navigate([link]);
      return;
    }
    const url = new URL(link);
    if (!url.origin.includes(this.urlInstitucion)) {
      window.open(link, '_blank');
    } else {
      window.location.href = url.href;
    }
  }

}
